import { render, staticRenderFns } from "./CommodityEvaluation.vue?vue&type=template&id=2852f714&"
import script from "./CommodityEvaluation.vue?vue&type=script&lang=js&"
export * from "./CommodityEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./CommodityEvaluation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports